// Minimal stand-in for shadcn's cn(): joins truthy strings and object keys whose values are truthy.
export function cn(...args) {
  return args
    .flatMap((a) => (a && typeof a === 'object' ? Object.keys(a).filter((k) => a[k]) : [a]))
    .filter(Boolean)
    .join(' ');
}
